import { render, staticRenderFns } from "./calculate.vue?vue&type=template&id=2154c4c4&scoped=true"
import script from "./calculate.vue?vue&type=script&lang=js"
export * from "./calculate.vue?vue&type=script&lang=js"
import style0 from "./calculate.vue?vue&type=style&index=0&id=2154c4c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2154c4c4",
  null
  
)

export default component.exports